import { Config } from '../shared';

export const getLegacyRoutePath = (path?: string) => `${Config.originUrl}${path}`;
